import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import { H3, SectionText } from '../../components';

const hasText = value => typeof value === 'string' && value.trim().length > 0;

/**
 * Render structured training details sections for ListingPage.
 *
 * Note: This intentionally does not add custom styling.
 */
const TrainingDetailsSections = props => {
  const { description, publicData } = props;
  const {
    learningPoints,
    trainingSchedule,
    trainingFor,
    importantInformation,
  } = publicData || {};

  const points = Array.isArray(learningPoints)
    ? learningPoints.filter(p => typeof p === 'string' && p.trim().length)
    : [];

  const hasAny =
    hasText(description) ||
    points.length > 0 ||
    hasText(trainingSchedule) ||
    hasText(trainingFor) ||
    hasText(importantInformation);

  if (!hasAny) return null;

  return (
    <div>
      {hasText(description) ? (
        <>
          <H3 as="h2">
            <FormattedMessage id="ListingPage.training.aboutTitle" />
          </H3>
          <SectionText text={description} />
        </>
      ) : null}

      {points.length > 0 ? (
        <>
          <H3 as="h2">
            <FormattedMessage id="ListingPage.training.learnTitle" />
          </H3>
          <ul>
            {points.map((p, idx) => (
              <li key={`${idx}-${p}`}>{p}</li>
            ))}
          </ul>
        </>
      ) : null}

      {hasText(trainingSchedule) ? (
        <>
          <H3 as="h2">
            <FormattedMessage id="ListingPage.training.scheduleTitle" />
          </H3>
          <SectionText text={trainingSchedule} />
        </>
      ) : null}

      {hasText(trainingFor) ? (
        <>
          <H3 as="h2">
            <FormattedMessage id="ListingPage.training.forTitle" />
          </H3>
          <SectionText text={trainingFor} />
        </>
      ) : null}

      {hasText(importantInformation) ? (
        <>
          <H3 as="h2">
            <FormattedMessage id="ListingPage.training.importantTitle" />
          </H3>
          <SectionText text={importantInformation} />
        </>
      ) : null}
    </div>
  );
};

export default TrainingDetailsSections;

